export default __webpack_public_path__ + "static/media/promocionAlarma1Mobile.3044e9da.png";